export default "__VITE_ASSET__Cs47nA_Q__"